// Store listings of the current (lite, free + subscriptions) app. The old paid
// app is no longer sold, so the site never links to it.
export const APP_STORE_URL =
  "https://apps.apple.com/us/app/lite-%D8%AA%D8%B1-%D8%A8-%D8%B9/id6474274690";
export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.azmenezi.makhmikhhafront&hl=ar";
export const INSTAGRAM_URL = "https://www.instagram.com/tarbaakw/";
